export const DataColumns = [
  {
    title: "S.No.",
    dataIndex: "serialNo",
    align: "center",
    render: (text) => (
      <div style={{ textAlign: "center" }}>
        {text}
      </div>
    ),
  },
  {
    title: "Name",
    dataIndex: "name",
    align: "center",
    render: (text) => (
      <div style={{
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        width:'230px',    
        textAlign:'center',
        margin: '0 auto'
      }}>
        {text}
      </div>
    ),
  },
  {
    title: "API Key",
    dataIndex: "apiKey",
    align: "center",
    render: (text) => (
      <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
        {text}
      </div>
    ),
  },
  {
    title: "API Secret Key",
    dataIndex: "apiSecret",
    align: "center",
    render: (text) => (
      <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
        {text}
      </div>
    ),
  },
  {
    title: "Action",
    dataIndex: "action",
    align: "center",
    render: (text) => (
      <div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
        {text}
      </div>
    ),
  },
];
